import React from "react";
import PropTypes from "prop-types";
import { ReactComponent as MuzoneWaveMark } from "../../../images/muzone-wave-mark.svg";
import "./index.css";

const AuthBrandTitle = ({ label }) => (
    <span className="auth-brand-title">
        <MuzoneWaveMark className="auth-brand-title__logo" aria-hidden="true" focusable="false" />
        <span className="auth-brand-title__label">{label}</span>
    </span>
);

AuthBrandTitle.propTypes = {
    label: PropTypes.string.isRequired,
};

export default AuthBrandTitle;
